import { unix } from 'moment-timezone';
import { utc } from 'moment';
import { map, publishReplay, refCount, take } from 'rxjs/operators';
import { S2AHttpClient } from '@s2a/ng-common';
import { Injectable, NgModule, defineInjectable, inject } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function isEqual(a, b) {
    if (a == null || b == null) {
        return false;
    }
    return a.from === b.from && a.name === b.name && a.duration === b.duration;
}
/**
 * @param {?} shift
 * @param {?} timezone
 * @return {?}
 */
function getShiftDescription(shift, timezone) {
    /** @type {?} */
    var shiftBegin = unix(shift.from / 1000).tz(timezone);
    /** @type {?} */
    var shiftEnd = unix(shift.from / 1000).add(shift.duration, 'h').tz(timezone);
    /** @type {?} */
    var shiftName = 'not available';
    if (shift.name !== undefined) {
        shiftName = shift.name;
    }
    return shiftBegin.format('MM-DD-YYYY - h:mm a') + " - " + shiftEnd.format('h:mm a') + " - " + shiftName;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ShiftService = /** @class */ (function () {
    function ShiftService(s2aHttpClient) {
        this.s2aHttpClient = s2aHttpClient;
        this.shiftCache$ = {};
    }
    /**
     * @param {?} lineId
     * @return {?}
     */
    ShiftService.prototype.getShiftModel = /**
     * @param {?} lineId
     * @return {?}
     */
    function (lineId) {
        if (!this.shiftCache$[lineId]) {
            this.shiftCache$[lineId] = this.s2aHttpClient.get("shift/" + lineId)
                .pipe(map(function (result) { return result.dailySchedule; }), publishReplay(1, 5000), // 5 second cache window
            // 5 second cache window
            refCount(), take(1));
        }
        return this.shiftCache$[lineId];
    };
    /**
     * @param {?} lineId
     * @return {?}
     */
    ShiftService.prototype.getLastCompletedShift = /**
     * @param {?} lineId
     * @return {?}
     */
    function (lineId) {
        return this.getShiftModel(lineId).pipe(
        // TODO rework this stuff
        map(function (result) {
            if (!result.shifts) {
                return [];
            }
            return result.shifts
                .map(function (shift) {
                /** @type {?} */
                var begin = utc(shift.time, 'HH:mm');
                return /** @type {?} */ ({
                    duration: result.duration,
                    name: shift.name,
                    time: shift.time,
                    begin: begin,
                    end: utc(begin).add(result.duration, 'h')
                });
            })
                .sort(sortDatesDescending);
        }), map(function (todaysShifts) {
            var _loop_1 = function (daysBack) {
                /** @type {?} */
                var shift = todaysShifts.find(function (todaysShift) { return utc().isAfter(todaysShift.end.subtract(daysBack, 'd')); });
                if (shift === undefined) {
                    return "continue";
                }
                /** @type {?} */
                var beginOfShift = shift.begin.subtract(daysBack, 'd').utc();
                return { value: {
                        from: beginOfShift.unix() * 1000,
                        duration: shift.duration,
                        name: shift.name
                    } };
            };
            // TODO rework this strange loop
            for (var daysBack = 0; true; daysBack++) {
                var state_1 = _loop_1(daysBack);
                if (typeof state_1 === "object")
                    return state_1.value;
            }
        }));
    };
    ShiftService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    ShiftService.ctorParameters = function () { return [
        { type: S2AHttpClient }
    ]; };
    /** @nocollapse */ ShiftService.ngInjectableDef = defineInjectable({ factory: function ShiftService_Factory() { return new ShiftService(inject(S2AHttpClient)); }, token: ShiftService, providedIn: "root" });
    return ShiftService;
}());
/**
 * @param {?} left
 * @param {?} right
 * @return {?}
 */
function sortDatesDescending(left, right) {
    return right.end.diff(left.end);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var NgShiftsModule = /** @class */ (function () {
    function NgShiftsModule() {
    }
    /**
     * @return {?}
     */
    NgShiftsModule.forRoot = /**
     * @return {?}
     */
    function () {
        return {
            ngModule: NgShiftsModule,
            providers: [
                ShiftService
            ]
        };
    };
    NgShiftsModule.decorators = [
        { type: NgModule, args: [{
                    imports: [],
                    declarations: [],
                    exports: []
                },] }
    ];
    return NgShiftsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { isEqual, getShiftDescription, ShiftService, NgShiftsModule };

//# sourceMappingURL=s2a-ng-shifts.js.map